
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/auth/regras-meia-entrada",
      function () {
        return require("private-next-pages/auth/regras-meia-entrada.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/auth/regras-meia-entrada"])
      });
    }
  